import React from 'react'
import { LogoutPipeline, useAuth } from '@morningtrain/react-auth'
import MenuItem from 'widgets/navigation/MenuItem'
import SidebarMenuItem from 'ui/navigation/SidebarMenuItem'
import SVGIcon from 'ui/helpers/SVGIcon'

export default function AdminMainNavigation () {
  const linksLabel = useAuth().user.get('role_name') === 'admin'
    ? 'Linkadministration'
    : 'Dine links'

  return (
    <>
      {/* Border */}
      <div className='mx-8 mt-8 mb-6 border-t border-gray-300' />

      {/* Top navigation */}
      <nav className='flex-1 bg-white space-y-1'>
        <MenuItem route='app.users.admins.index' svgIcon={<SVGIcon type='admin' />} />
        <MenuItem route='app.customers.index' svgIcon={<SVGIcon type='users' />} />
        <MenuItem route='app.domains.index' svgIcon={<SVGIcon type='earth' />} />
        <MenuItem route='app.shop.domains.index' svgIcon={<SVGIcon type='link' />} />
        <MenuItem route='app.links.index' label={linksLabel} svgIcon={<SVGIcon type='tag' />} />
        <MenuItem route='app.shop.cart.index' svgIcon={<SVGIcon type='cart' />} />
      </nav>

      {/* Border */}
      <div className='mx-8 mt-8 mb-6 border-t border-gray-300' />

      {/* Bottom navigation */}
      <nav>
        <LogoutPipeline>
          <SidebarMenuItem text='Log ud' svgIcon={<SVGIcon type='logout' />} />
        </LogoutPipeline>
      </nav>
    </>
  )
}
